/**
 * IMPORTS
 */

const dataTitleTableHistory = [
  { label: "Remessa", accessor: "numero_remessa" },
  { label: "Qtd", accessor: "quantidadeSolicitacao" },
  {
    label: "status",
    accessor: "status",
    isBadge: true,
    badgeClassName: "bg-green-500",
  },
  { label: "modelo", accessor: "nome_modelo" },
  { label: "Responsável", accessor: "designer" },
  { label: "Data Solicitação", accessor: "data" },
];

/**
 * EXPORTS
 */
export { dataTitleTableHistory };
